const CustomModal = function () {


    showCmodal = (el) => {
        let modalChoosed = el.attr('data-modalC');
        $(modalChoosed).addClass('modal-show');
    }

    closeCmodal = (el) => {
        el.closest('.modalC').removeClass('modal-show');
    }


    return {

        init : () => {

            $('.callModalC').on('click', function() {
                showCmodal( $(this) );
            })
            $('.closeModalC').on('click', function() {
                closeCmodal( $(this) );
            })

        }

    }

}();

module.exports = CustomModal;